export default {
  fromStore(resourcesToTasks, ganttInstance) {
    ganttInstance.batchUpdate(() => {
      resourcesToTasks.forEach(({ taskId, resourcesToTask }) => {
        if (!ganttInstance.isTaskExists(taskId)) {
          return;
        }

        const ganttTask = ganttInstance.getTask(taskId);

        ganttInstance.silent(() => {
          ganttTask.resources = resourcesToTask;
        });
      });
    });
  },

  fromGantt() {

  },
};
